var minPrice = 0;
var maxPrice = 0;
var minNight = 0;
var maxNight = 0;
var wait=0;
var tourSearchFilter = function() {

	this.init = function (){
		$("#filterByName").keyup(function() {
			applyFilter();
		});
		
		$("input[type='checkbox'][name='filterType']").click(function() {
			applyFilter();
		});
		
		$("input[type='checkbox'][name='location']").click(function() {
			applyFilter();
		});
		
		$("input[type='checkbox'][name='provider']").click(function() {
			applyFilter();
		});
		
		$("input[type='checkbox'][name='saletype']").click(function() {
			applyFilter();
		});
		
		$("input[type='checkbox'][name='transport']").click(function() {
			applyFilter();
		});
		
		if(Tour.resultTable != null){
			var resultText = Tour.resultTable.length + ' ' + FmtMessage.getMessage('js.search.tour.result.found');
			$('.notice').html(resultText);
			minPrice = $(Tour.resultTable.first()).attr("data-minprice");
			maxPrice = $(Tour.resultTable.last()).attr("data-minprice");
			maxNight = $("#maxTourNight").val();

			var minSliderValue = parseInt(minPrice / 10, 10) * 10;
			var maxSliderValue = parseInt(maxPrice / 10, 10) * 10 + 10;
			
			//PRICE SLIDER #1
			$("#slider-range1").slider({
				range: true,
				min: minSliderValue,
				max: maxSliderValue,
				values: [ minSliderValue, maxSliderValue ],
				step: 10,
				slide: function(event, ui) {
					$("#filterByPrice").val(ui.values[0] + " " + $.cookie('currency') + " - " + ui.values[1] + " " + $.cookie('currency'));
				}
			});
			
			$("#filterByPrice").val($("#slider-range1").slider("values", 0) + " " + $.cookie('currency') + " - " + $("#slider-range1").slider("values", 1) + " " + $.cookie('currency'));
			
			$("#slider-range1").slider({change: function(event, ui) {
				applyFilter();
				$('#resetFilterPrice').show();
			}});
			
			//NIGHT SLIDER #1
			$("#slider-range2").slider({
				range: true,
				min: 0,
				max: maxNight,
				values: [ 0, maxNight ],
				step: 1,
				slide: function(event, ui) {
					$("#filterByNight").val(ui.values[0] + " - " + ui.values[1]);
				}
			});
			
			$("#filterByNight").val($("#slider-range2").slider("values", 0) + " - " + $("#slider-range2").slider("values", 1));
			
			$("#slider-range2").slider({change: function(event, ui) {
				applyFilter();
				$('#resetFilterNight').show();
			}});
		}

	}

    $(".hideShowPopup").click(function() {
        $('.resultLeft').fadeToggle("fast");
        return false;
    });


	this.applyFilter = function() {
		if(wait==1) return;
		$('.resultNotFound').hide();
		$('.sortselect').show();
		$('.notice').show();
		var hasResult = false;
		var filter = getFilter();
		var availableCount = 0;
		Tour.resultTable.each(function(index, item){
			var show = isMatchesFilter(item, filter);
			if(show){
                availableCount++;
				hasResult = true;
                $( item ).show();
			}
			else{
                $( item ).hide();
			}
		});

        var resultText = availableCount + ' ' + FmtMessage.getMessage('js.search.tour.result.found');
        $('.notice').html(resultText);

		if (!hasResult){
            $('.resultNotFound').show();
            $('.sortselect').hide();
            $('.notice').hide();
        }
	}
	
	function _fnEscapeRegex ( sVal ) {
		var letters = { "İ": "[İi]", "I": "[Iı]", "Ş": "[Şş]", "Ğ": "[Ğğ]", "Ü": "[Üü]", "Ö": "[Öö]", "Ç": "[Çç]", "i": "[İi]", "ı": "[Iı]", "ş": "[Şş]", "ğ": "[Ğğ]", "ü": "[Üü]", "ö": "[Öö]", "ç": "[Çç]" };
		return sVal.replace(/(([İIŞĞÜÇÖiışğüçö]))/g, function (letter) { return letters[letter]; });
	}

	var isMatchesFilter = function(item, filter){
	
		if(filter.name.length > 0){
			
			var _name = _fnEscapeRegex(filter.name).toLowerCase();
			var itemName = _fnEscapeRegex($(item).attr("data-tourname")).toLowerCase();

			if(itemName.indexOf(_name) < 0){		
				return false;
			}
		} 

		if($(item).attr("data-type") in filter.types && !filter.types[$(item).attr("data-type")]){
			return false;
		}
		
		if($(item).attr("data-location") in filter.locations && !filter.locations[$(item).attr("data-location")]){
			return false;
		}

		if($(item).attr("data-provider") in filter.providers && !filter.providers[$(item).attr("data-provider")]){
			return false;
		}
		
		if($(item).attr("data-saletype") in filter.saletypes && !filter.saletypes[$(item).attr("data-saletype")]){
			return false;
		}
		
		if($(item).attr("data-transport") in filter.transports && !filter.transports[$(item).attr("data-transport")]){
			return false;
		}

		if(filter.minprice > $(item).attr("data-minprice") || filter.maxprice < $(item).attr("data-minprice"))
			return false;
		
		if(filter.minnight > $(item).attr("data-tournight") || filter.maxnight < $(item).attr("data-tournight"))
			return false;
	
		return true;
	}

    $("#searchSorting").change(function(){
        var optionSelected = $("option:selected", this);

        var attribute = optionSelected.attr("data-filter-attribute");
        var direction = optionSelected.attr("data-filter-direction");

        if (attribute == 'price'){
            sortByPrice(direction);
		}
		else {
            sortByName(direction)
		}
    });

    var resetPriceFilter = function() {
		$('#slider-range1').slider('values', [minPrice, maxPrice]);
        $("#filterByPrice").val(minPrice + " " + $.cookie('currency') + " - " + maxPrice + " " + $.cookie('currency'));
		applyFilter();
    }
    
    var resetNightFilter = function() {
		$('#slider-range2').slider('values', [0, maxNight]);
        $("#filterByNight").val(0 + " - " + maxNight);
		applyFilter();
    }

	var resetFilter = function(filterName) {
		if (filterName == 'filterByPrice'){
			resetPriceFilter();
		}else if (filterName == 'filterByNight'){
			resetNightFilter();
		} else { selectAll(filterName);}
    }
	
	var unSelectAll = function(filter) {
	  wait=1;
	  $('.'+filter).iCheck('uncheck');
	  $('.reset-'+filter).show();
	  wait=0;
	  applyFilter();
	}
	
	var selectAll = function(filter) {
		  wait=1;
		  $('.'+filter).iCheck('check');
		  $('.reset-'+filter).hide();
		  wait=0;
		  applyFilter();
		}
	
	
	var $types = $(".filter-type");
	var $tourNameFilter = $("#filterByName");
	var $locations = $(".filter-location");
	var $providers = $(".filter-provider");
	var $saletypes = $(".filter-saletype");
	var $transports= $(".filter-transport");
	
	var getFilter = function(){

		var types = {}
		$types.each(function(index, item){
			types[item.value] = $(item).prop("checked");
		});
		
		var locations = {}
		$locations.each(function(index, item){
			locations[item.value] = $(item).prop("checked");
		});
		
		var providers = {}
		$providers.each(function(index, item){
			providers[item.value] = $(item).prop("checked");
		});
		
		var saletypes = {}
		$saletypes.each(function(index, item){
			saletypes[item.value] = $(item).prop("checked");
		});
		
		var transports= {}
		$transports.each(function(index, item){
			transports[item.value] = $(item).prop("checked");
		});
		
		return {
			minprice : $("#slider-range1").slider("values", 0),
			maxprice : $("#slider-range1").slider("values", 1),
			minnight : $("#slider-range2").slider("values", 0),
			maxnight : $("#slider-range2").slider("values", 1),
			name : $tourNameFilter.val(),
			types : types,
			locations : locations,
			providers : providers,
			saletypes : saletypes,
			transports: transports
		}
	}

	var sortByPrice = function(direction){
        Tour.resultTable.sort(function (t1, t2) {
        	t1 = $(t1).attr('data-minprice');
            t2 = $(t2).attr('data-minprice');
            return direction == 'asc' ? t1 - t2 : t2 - t1;
		}).appendTo('#tourResultTable')
	}


    var sortByName = function(direction){
		var reverse = direction == 'asc' ? 1 : -1;
       	Tour.resultTable.sort(function (t1, t2) {
            t1 = $(t1).attr('data-tourname');
            t2 = $(t2).attr('data-tourname');
            t1 = t1.replace(/[|&;$%@"<>()+,*&()[\]:\-]/g, "");
            t2 = t2.replace(/[|&;$%@"<>()+,*&()[\]:\-]/g, "");
			t1 = t1.replace(/ /g, '');
            t2 = t2.replace(/ /g, '');


            if (t1.toLowerCase() > t2.toLowerCase()){
				return reverse * 1;
			}
            else if (t1.toLowerCase() < t2.toLowerCase()){
				return -1 * reverse;
            }
            return 0;
        }).appendTo('#tourResultTable');

	}

	return {
		init : init,
		applyFilter : applyFilter,
		resetFilter : resetFilter,
		unSelectAll : unSelectAll
	}
	
}();

